<template>
  <div class="layer notranslate">
    <div ref="toastInner" class="inner">
      <pre v-if="emMessage" class="emMessage">{{ emMessage }}</pre>
      <pre v-if="emMessage2" class="emMessage2">{{ emMessage2 }}</pre>
      <pre>{{ message }}</pre>
      <div class="btns">
        <button v-if="type === 'confirm'" type="button" class="btn btnWhite" @click="confirm($event, false)">{{ locale.cancel }}</button>
        <button type="button" class="btn" :class="{btnFull: type === 'alert'}" :style="defaultBtnStyle" ref="confirmBtn" @click="confirm($event, true)">{{ confirmTxt || locale.confirm }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'locale',
    'lang',
    'toast'
  ],
  computed: {
    id () {
      return this.toast.id
    },
    message () {
      return this.toast.message
    },
    emMessage () {
      return this.toast.emMessage
    },
    emMessage2 () {
      return this.toast.emMessage2
    },
    confirmTxt () {
      return this.toast.confirmTxt
    },
    type () {
      return this.toast.type
    },
    defaultBtnStyle () {
      return this.$store.getters['common/getDefaultBtnStyle']
    }
  },
  mounted () {
    this.$root.$el.append(this.$el)
    this.$nextTick(() => {
      const toastInner = this.$refs.toastInner
      const confirmBtn = this.$refs.confirmBtn
      document.body.classList.add('layerOn')
      if (toastInner) {
        toastInner.classList.add('enter')
      }
      if (confirmBtn) {
        confirmBtn.focus()
      }
    })
  },
  beforeDestroy () {
    document.body.classList.remove('layerOn')
    if (this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el)
    }
  },
  data () {
    return {
    }
  },
  methods: {
    confirm (e, isConfirm) {
      const id = this.id
      const otherData = this.toast.otherData
      e.stopPropagation()
      this.$emit('confirm', { id: id, isConfirm: isConfirm, otherData })
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  padding-bottom: 60px;
  .inner {
    min-width: 280px;
    max-width: 400px;
    height: auto;
    margin-top: -45px;
    white-space: pre-wrap;
    padding: 30px;
    font-size: 18px;
    border-radius: 8px;
    opacity: 0;
    &.enter {
      margin-top: 0;
      opacity: 1;
      animation-name: enter;
      animation-duration: 0.5s;
    }
  }
  .btns {
    padding-top: 30px;
  }
  .btn {
    padding-left: 5px;
    padding-right: 5px;
  }
  .emMessage {
    margin-bottom: 8px;
    font-size: 1.3em;
    font-weight: bold;
  }
  .emMessage2 {
    margin-bottom: 8px;
    font-size: 1.2em;
  }
  pre {
    white-space: pre-wrap; /* 긴 단어는 자동으로 줄 바꿈 */
    word-wrap: break-word; /* 긴 단어의 줄 바꿈을 허용 */
    hyphens: none; /* 하이픈 생성을 비활성화 */
    overflow: auto; /* 내용이 넘칠 때 스크롤 표시 */
    transition: none; /* 애니메이션 제거 */
    animation: none; /* 애니메이션 제거 */
  }
}
@keyframes enter {
  from {
    margin-top: -45px;
    opacity: 0;
  }
  to {
    margin-top: 0;
    opacity: 1;
  }
}
@media screen and (min-width: 768px) {
  .layer {
    .inner {
      max-width: 560px;
      padding: 30px 20px 20px;
      text-align: center;
      font-size: 22px;
    }
    .btns {
      font-size: inherit;
      .btn {
        padding-top: 8px;
        padding-bottom: 8px;
        font-size: inherit;
      }
    }
  }
}
</style>
